var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrawerBellActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4789 16.0765C18.4749 16.727 17.9668 17.3457 17.2145 17.3457H2.09659C1.34507 17.3457 0.836571 16.727 0.833026 16.0765C0.831305 15.7561 0.952845 15.4475 1.17216 15.2154C1.93313 14.392 3.35701 13.1529 3.35701 9.0957C3.35701 6.01385 5.50287 3.54678 8.39631 2.94152V2.11493C8.39631 1.77831 8.52911 1.45548 8.76548 1.21745C9.00185 0.979425 9.32245 0.845703 9.65673 0.845703C9.99101 0.845703 10.3116 0.979425 10.548 1.21745C10.7844 1.45548 10.9171 1.77831 10.9171 2.11493V2.94152C13.8082 3.54678 15.9541 6.01385 15.9541 9.0957C15.9541 13.1533 17.378 14.392 18.1389 15.2154C18.3585 15.4474 18.4803 15.756 18.4789 16.0765Z",
    fill: "#00A0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.13477 18.6152H12.1764C12.1764 19.2885 11.9108 19.9341 11.4381 20.4102C10.9653 20.8863 10.3242 21.1537 9.6556 21.1537C8.98703 21.1537 8.34585 20.8863 7.8731 20.4102C7.40035 19.9341 7.13477 19.2885 7.13477 18.6152Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerBellActive);
export default __webpack_public_path__ + "static/media/DrawerBellActive.29f01f3e.svg";
export { ForwardRef as ReactComponent };